import React, { useState, useEffect, useMemo } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import styled from "styled-components";

import VideoList from "../VideoList";
import MemoizedAppHeader from "../AppHeader";
import Modal from "../Modal";
import VideoDetail from "../VideoDetail";
import Container from "../shared/Container";

import { throttle, debounce } from "lodash";

import { searchYoutube } from "../../api/youtube.js";

const Main = styled.main`
  margin-top: 110px;
`;

export default function App() {
  const location = useLocation();
  const [searchListResponse, setSearchListResponse] = useState({
    nextPageToken: "",
    items: [],
  });
  const [option, setOption] = useState({
    maxResults: 10,
    type: "video",
    pageToken: "",
  });

  const handleTextChange = (e) => {
    window.scrollTo(0, 0);

    setSearchListResponse((searchListResponse) => ({
      ...searchListResponse,
      nextPageToken: "",
      items: [],
    }));
    setOption((option) => ({
      ...option,
      maxResults: 10,
      q: e.target.value,
      pageToken: "",
    }));
  };

  const debouncedHandleTextChange = useMemo(
    () => debounce(handleTextChange, 500),
    []
  );

  const doSearchYoutube = async (option) => {
    try {
      const data = await searchYoutube(option);

      setSearchListResponse((searchListResponse) => ({
        ...searchListResponse,
        nextPageToken: data.nextPageToken,
        items: searchListResponse.items.concat(data.items),
      }));
    } catch (error) {
      console.warn("요청 오류", error);
    }
  };

  useEffect(() => {
    if (searchListResponse.nextPageToken) {
      setOption((option) => ({
        ...option,
        maxResults: 50,
        pageToken: searchListResponse.nextPageToken,
      }));
    }
  }, [searchListResponse]);

  useEffect(() => {
    if (!option.pageToken) {
      doSearchYoutube(option);
    }

    const handleScrollevent = throttle(() => {
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
        doSearchYoutube(option);
      }
    }, 500);

    window.addEventListener("scroll", handleScrollevent);

    return () => window.removeEventListener("scroll", handleScrollevent);
  }, [option]);

  return (
    <>
      <MemoizedAppHeader onInputChange={debouncedHandleTextChange} />
      <Main>
        <Container>
          <Routes location={location.state?.backgroundLocation || location}>
            <Route
              path="/videos"
              element={<VideoList videos={searchListResponse.items} />}
            />
            <Route
              path="/"
              element={
                <Navigate
                  to="/videos"
                  replace
                  state={{ isFirstLoading: true }}
                />
              }
            />
          </Routes>

          {location.state?.backgroundLocation && (
            <Routes>
              <Route
                path="/videos/:videoId"
                element={
                  <Modal>
                    <VideoDetail />
                  </Modal>
                }
              />
            </Routes>
          )}
        </Container>
      </Main>
    </>
  );
}
